import { isoCurrenciesByCode } from './abacusCurrency';

const defaultCurrencyCode = 'USD';

/**
 * Given an amount in minor units and a currencyCode, render the formatted amount with symbols
 * @param amountInMajorUnits - amount in minor units,
 * @param currencyCode - the currency code
 * @deprecated - we should use abacusCurrency class for all currency manipulations
 */
export function getFormattedCurrencyStringFromMinorUnits(amountInMinorUnits: number, currencyCode: string = defaultCurrencyCode) {
  if (!isoCurrenciesByCode[currencyCode]) {
    throw new Error(`expected valid currency code, received: ${currencyCode}`);
  }
  const amountInMajorUnits = convertToMajorUnitNumber(amountInMinorUnits, currencyCode);
  return amountInMajorUnits.toLocaleString('en', { style: 'currency', currency: currencyCode });
}

/**
 * Given an amount and an optional currency code return the equivalent value in major units.
 * @param amount an amount in minor currency units
 * @param currencyCode an optional currency code defaulting to USD
 * @deprecated - we should use abacusCurrency class for all currency manipulations
 */
export function convertToMajorUnits(amount: number, currencyCode?: string) {
  if (!currencyCode) {
    currencyCode = defaultCurrencyCode;
  }

  if (!isoCurrenciesByCode[currencyCode]) {
    throw new Error(`expected valid currency code, received: ${currencyCode}`);
  }
  const currency = isoCurrenciesByCode[currencyCode];
  const unitConversionRate = currency.exponent;
  const convertedAmount = amount / Math.pow(10, unitConversionRate);

  return getAmountWithFormattedFractionalCurrency(convertedAmount, currencyCode);
}

/**
 *
 * @param amount
 * @param currencyCode
 * @deprecated - we should use abacusCurrency class for all currency manipulations
 * @returns
 *
 */
export function convertToMajorUnitNumber(amount: number, currencyCode?: string) {
  const str = convertToMajorUnits(amount, currencyCode);
  return parseFloat(str);
}

/**
 * Given an amount and an optional currency code return the equivalent value in minor units.
 * @param amount an amount in major currency units
 * @param currencyCode an optional currency code defaulting to USD
 * @deprecated - we should use abacusCurrency class for all currency manipulations
 */
export function convertToMinorUnits(amount: number, currencyCode?: string) {
  if (!currencyCode) {
    currencyCode = defaultCurrencyCode;
  }

  if (!isoCurrenciesByCode[currencyCode]) {
    throw new Error(`expected valid currency code, received: ${currencyCode}`);
  }
  const currency = isoCurrenciesByCode[currencyCode];
  const unitConversionRate = currency.exponent;
  return Math.round(amount * Math.pow(10, unitConversionRate));
}

/**
 * Returns the formatted amount as a float trimmed to the correct number of decimal spaces for the currency
 * @param amountInMajorUnits
 * @param currencyCode
 * @deprecated - we should use abacusCurrency class for all currency manipulations
 */
export function getAmountWithFormattedFractionalCurrency(amountInMajorUnits: number, currencyCode?: string) {
  if (!currencyCode) {
    currencyCode = defaultCurrencyCode;
  }

  if (!isoCurrenciesByCode[currencyCode]) {
    throw new Error(`expected valid currency code, received: ${currencyCode}`);
  }
  const currency = isoCurrenciesByCode[currencyCode];
  const unitConversionRate = currency.exponent;

  // .toFixed will round numbers starting with the first value beyond the desired decimal cut off.
  return amountInMajorUnits.toFixed(unitConversionRate);
}
